import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgControlIconAdd({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M8.5 2c.28 0 .5.22.5.5V7h4.5c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5H9v4.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V9H2.5a.5.5 0 01-.5-.5v-1c0-.28.22-.5.5-.5H7V2.5c0-.28.22-.5.5-.5h1z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgControlIconAdd.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgControlIconAdd.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgControlIconAdd svgRef={ref} {...props} />);
export default ForwardRef;
